// extracted by mini-css-extract-plugin
export var root = "H_wv";
export var wrapper = "H_ww";
export var image = "H_wx d_w d_y d_W";
export var imageWithHeight = "H_wy";
export var crop = "H_wz";
export var round = "H_wB";
export var fixedHeight = "H_wC";